/**
 * @desc 账号登录
 */
import { LoginResult, LoginMfaForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type LoginMemberByMfaParameter = LoginMfaForm

const method = 'POST'
const url = '/auth/member/login/mfa'

export const loginMemberByMfaApi = (
  data?: LoginMemberByMfaParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<LoginResult>({
    method,
    url,
    data,
    ...config
  })
}

loginMemberByMfaApi.method = method
loginMemberByMfaApi.url = url
